"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getData = exports.setData = void 0;
function setData(data) {
    if (data) {
        return JSON.stringify(data);
    }
    return null;
}
exports.setData = setData;
function getData(dataJson) {
    if (dataJson) {
        return JSON.parse(dataJson);
    }
    return dataJson;
}
exports.getData = getData;

//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kYXRhL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLFNBQWdCLE9BQU8sQ0FBQyxJQUFTO0lBQy9CLElBQUksSUFBSSxFQUFFLENBQUM7UUFDVCxPQUFPLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDOUIsQ0FBQztJQUVELE9BQU8sSUFBSSxDQUFDO0FBQ2QsQ0FBQztBQU5ELDBCQU1DO0FBRUQsU0FBZ0IsT0FBTyxDQUFDLFFBQWE7SUFDbkMsSUFBSSxRQUFRLEVBQUUsQ0FBQztRQUNiLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUM5QixDQUFDO0lBRUQsT0FBTyxRQUFRLENBQUM7QUFDbEIsQ0FBQztBQU5ELDBCQU1DIiwiZmlsZSI6ImRhdGEvaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZnVuY3Rpb24gc2V0RGF0YShkYXRhOiBhbnkpOiBzdHJpbmcgfCBudWxsIHtcbiAgaWYgKGRhdGEpIHtcbiAgICByZXR1cm4gSlNPTi5zdHJpbmdpZnkoZGF0YSk7XG4gIH1cblxuICByZXR1cm4gbnVsbDtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGdldERhdGEoZGF0YUpzb246IGFueSk6IG9iamVjdCB7XG4gIGlmIChkYXRhSnNvbikge1xuICAgIHJldHVybiBKU09OLnBhcnNlKGRhdGFKc29uKTtcbiAgfVxuXG4gIHJldHVybiBkYXRhSnNvbjtcbn1cbiJdfQ==
